module.exports = __webpack_public_path__ + "assets/icons/ic_small_alert.svg";